import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { theme } from "src/config";
import { FleetConfigDialog } from "src/components/FleetConfigDialog";

interface Props {}

export function FleetConfigPage(props: Props) {
  const {
    caseId = "",
    scenarioId = "",
    lezId = "",
  } = useParams<{
    caseId: string;
    scenarioId: string;
    lezId: string;
  }>();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  function close() {
    setOpen(false);

    setTimeout(() => {
      navigate(`/cases/${caseId}/scenarios/${scenarioId}/lezs/${lezId}`);
    }, theme.transitions.duration.leavingScreen);
  }

  return render();

  function render() {
    return <FleetConfigDialog onClose={close} open={open} scenarioId={scenarioId} lezId={lezId} caseId={caseId} />;
  }
}
